/**
 * `/einladung` (#1825) asks this tab to show the join-invite modal once the app
 * is past its gates („Praxis wählen“, the legal step, onboarding). Held per tab,
 * so it survives the Keycloak login round trip and an office choice. Nothing
 * else ever opens the modal: without the link, declining needs no stored state.
 */
const JOIN_INVITE_REVIEW = 'join_invite_review';

export const requestJoinInviteReview = () => sessionStorage.setItem(JOIN_INVITE_REVIEW, '1');

/** Whether the modal was asked for; asking again needs the link again. */
export const takeJoinInviteReview = (): boolean => {
  const requested = sessionStorage.getItem(JOIN_INVITE_REVIEW) === '1';
  sessionStorage.removeItem(JOIN_INVITE_REVIEW);
  return requested;
};
